import { SORTING_DIRECTION } from 'src/constants/main';
import { ICurrency } from 'src/types/currency';
import {
  CURRENCIES_SORT_COLUMN,
  ICurrenciesFilters,
  ICurrencyValidation,
} from 'src/view/screens/SettingsScreen/screens/General/LanguageCountryCurrency/types/currencies';

export const defaultCurrency: ICurrency = {
  id: 0,
  currency_name: '',
  currency_code: '',
  currency_code_ar: '',
  currency_symbol: '',
  currency_position: 'l',
  default_currency: 0,
  status: 1,
  created_by: 0,
  updated_by: 0,
  divided: undefined,
  created_at: new Date(),
  updated_at: new Date(),
};

export const defaultCurrenciesFilters: ICurrenciesFilters = {
  search: '',
  perPage: undefined,
  sortField: CURRENCIES_SORT_COLUMN.NAME,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultCurrencyValidation: ICurrencyValidation = {
  currency_name: {
    state: true,
  },
  currency_code: {
    state: true,
  },
  currency_code_ar: {
    state: true,
  },
  currency_symbol: {
    state: true,
  },
  divided: {
    state: true,
  },
};
